export default __webpack_public_path__ + "static/phillipines-4bdce951fc19c4af6f2ff557344b9bb2.webp";